import { FC, ChangeEvent, useState, useEffect, useRef, useMemo } from 'react';
import {
  Divider,
  Box,
  FormControl,
  InputLabel,
  Card,
  Table,
  TableBody,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Select,
  MenuItem,
  Typography,
  TextField,
  Grid,
  Button,
  InputAdornment,
  Checkbox,
  TableCell,
  ListSubheader
} from '@mui/material';
import styled from '@emotion/styled';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import { withStyles } from '@mui/styles';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { commonFilterForLeaves } from 'src/models/leave';
import { getMainLeaveList } from 'src/services/leaveService';
import { useNavigate } from 'react-router';
import { RootStateType } from 'src/store/RootReducer';
import { DatePicker } from '@mui/lab';

interface Filters {
  status?: any;
}

const RmPendingRequest = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getValues } = useForm<commonFilterForLeaves>();
  const employeeType = useSelector((state: RootStateType) => state.leaveManagementReducer.userDetails.employmentType);

  //temporally added due to technical issue in BE pagination(currentPageNo, currentPageSize)
  const currentPageNo: number = 1;
  const currentPageSize: number = 1000;
  const leaveRequestStatus = 'PENDING';
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [toggleFilter, setToggleFilter] = useState(false);
  const [requestorName, setRequestorName] = useState(' ');
  const [reportingManager, setReportingManager] = useState(' ');
  const [leaveType, setLeaveType] = useState(' ');
  const [searchString, setSearchString] = useState('');
  const [requestorNameList, setRequestorNameList] = useState([]);
  const [reportingManagerList, setReportingManagerList] = useState([]);
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isDisabled, setIsDisable] = useState(true);
  const [isClearTriggerd, setIsClearTriggerd] = useState(false);
  const [isDisabledClearBtn, setIsDisabledClearBtn] = useState<boolean>(true);
  const inputRefFrom = useRef<HTMLInputElement>(null);
  const inputRefTo = useRef<HTMLInputElement>(null);

  const [sortNameType, setSortNameType] = useState('asc');
  const [sortDate, setSortDate] = useState('desc');

  const [searchText, setSearchText] = useState<any>('');
  const [ selectFormDate, setSelectFormDate] = useState('');
  const [ selectToDate, setSelectToDate] = useState('');
  const [isDisabledEmployeeLeavesBtn, setIsDisabledEmployeeLeavesBtn] = useState<boolean>(false);

  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const initialDate = (isFromDate: Boolean) => {
    if (!isFromDate && fromDate) {
      const minDate = new Date(fromDate.split('/').reverse().join('-'));
      return minDate.toISOString().split("T")[0]
    } else {
      if (toDate) {
        const minDate = new Date(toDate.split('/').reverse().join('-'));
        return minDate.toISOString().split("T")[0]
      }
    }
    return null;
  }

  useEffect(() => {
    if (leaveList?.length && sortNameType === 'asc') {
      setLeaveList(leaveList.sort((a, b) => a.leaveRequester?.name.localeCompare(b.leaveRequester?.name)));
    } else if (leaveList?.length && sortNameType === 'desc') {
      setLeaveList(leaveList.sort((a, b) => b.leaveRequester?.name.localeCompare(a.leaveRequester?.name)));
    }
  }, [leaveList, sortNameType]);

  useEffect(() => {
    if (leaveList?.length && sortDate === 'asc') {
      setLeaveList(leaveList.sort((a, b) => a.id - b.id));
    } else if (leaveList?.length && sortDate === 'desc') {
      setLeaveList(leaveList.sort((a, b) => b.id - a.id));
    }
  }, [leaveList, sortDate]);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const applyFilters = (leaveList: any[]): any[] => {
    return leaveList.filter(() => {
      let matches = true;

      return matches;
    });
  };

  const applyPagination = (
    leaveList: any[],
    page: number,
    limit: number
  ): any[] => {
    return leaveList.slice(page * limit, page * limit + limit);
  };

  const filteredLeaveList = applyFilters(leaveList);

  const paginatedLeaveList = applyPagination(filteredLeaveList, page, limit);

  const checkAll = (isCheck) => {
    if(isCheck){
      leaveList.map(item => {
        item.isCheck = true;
      })
    } else {
      leaveList.map(item => {
        item.isCheck = false;
      })
    }
  }

  const getDropDownValues = (data) => {
    const leaveTypeList = data.map((item) => item.leaveType);
    const leaveRequesterList = data.map((item) => item.leaveRequester?.name);
    const leaveReportingList = data.map((item) => item.rm?.name);

    setLeaveTypeList(
      leaveTypeList.filter(
        (item, index) => leaveTypeList.indexOf(item) === index
      )
    );
    setRequestorNameList(
      leaveRequesterList.filter(
        (item, index) => leaveRequesterList.indexOf(item) === index
      )
    );
    setReportingManagerList(
      leaveReportingList.filter(
        (item, index) => leaveReportingList.indexOf(item) === index
      )
    );
  };

  const modifiedString = () => {
    let filter = getValues();
    filter.isEmpty = true;
    if (searchString) {
      filter.mainSearchParam = searchString;
      filter.isEmpty = false;
    }

    if (reportingManager !== ' ') {
      filter.reportingManagerName = reportingManager;
      filter.isEmpty = false;
    }

    if (requestorName !== ' ') {
      filter.requesterName = requestorName;
      filter.isEmpty = false;
    }

    if (leaveType !== ' ') {
      filter.leaveType = leaveType;
      filter.isEmpty = false;
    }

    if (fromDate) {
      filter.fromDate = fromDate;
      filter.isEmpty = false;
    }

    if (toDate) {
      filter.toDate = toDate;
      filter.isEmpty = false;
    }

    if (!filter.isEmpty) {
      return JSON.stringify(filter)
        .replace('"isEmpty":false,', '')
        .replace('{', '')
        .replace('}', '')
        .replace(/\"/g, '');
    } else {
      return null;
    }
  };

  const getLeaveList = (isReset?: boolean) => {
    dispatch(AppActions.showLoader());
    setIsClearTriggerd(isReset ? true : false);
    const isEligible = false;

    getMainLeaveList(
      leaveRequestStatus,
      currentPageNo,
      currentPageSize,
      isReset ? null : modifiedString(),
      isEligible
    )
      .then((res) => {
        if (res.data) {
          setPage(0);
          setLeaveList(res.data.data);
          if (isReset === false && res.data.data?.length) {
            getDropDownValues(res.data.data);
          }
          setIsClearTriggerd(false);
        }
        dispatch(AppActions.hideLoader());
      })
      .catch((e) => {
        setIsClearTriggerd(false);
        dispatch(AppActions.hideLoader());
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: e?.response?.data?.message,
            severity: 'error'
          })
        );
      });
  };

  const requestorNames = useMemo(
    () =>
      requestorNameList?.filter((option) => containsText(option, searchText)),
    [searchText, requestorNameList]
  );

  const reporterNames = useMemo(
    () =>
      reportingManagerList?.filter((option) =>
        containsText(option, searchText)
      ),
    [searchText, reportingManagerList]
  );

  const leaveTypes = useMemo(
    () => leaveTypeList?.filter((option) => containsText(option, searchText)),
    [searchText, leaveTypeList]
  );

  useEffect(() => {
    const makeApiCall = async () => {
      if (!isClearTriggerd) {
        try {
          dispatch(AppActions.showLoader());
          setPage(0);
          getLeaveList(false);
        } catch (e) {
          dispatch(AppActions.hideLoader());
        }
      }
    };

    const triggerCall = setTimeout(() => {
      makeApiCall();
    }, 500);

    return () => clearTimeout(triggerCall);
  }, [searchString]);

  // custom table row with different color
  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const [isSelectToDate, setIsSelectToDate] = useState('');
  const [isSelectFromDate, setIsSelectFromDate] = useState('');

   //set disabled filter button
   const filterMandatoryFled = (e) => {
    if (e) {
      fromDate
        ? toDate
          ? setIsDisable(false)
          : setIsDisable(true)
        : toDate
        ? fromDate
          ? setIsDisable(false)
          : setIsDisable(true)
        : setIsDisable(false);
    }
  };

  const isReportingManager = useSelector(
    (state: RootStateType) => state.leaveManagementReducer.isReportingManager
  );

  useEffect(() => {
    const user = window.localStorage.getItem('user');
    const userModel = JSON.parse(user);
    const selectedUserRole = userModel?.Roles;

    if (
      selectedUserRole.split(',').includes('Super User') ||
      selectedUserRole.split(',').includes('HR Manager') ||
      selectedUserRole.split(',').includes('Assistant HR Manager') ||
      selectedUserRole.split(',').includes('HR Executive')
    ) {
      setIsDisabledEmployeeLeavesBtn(true);
    } else if (isReportingManager) {
      setIsDisabledEmployeeLeavesBtn(true);
    } else {
      setIsDisabledEmployeeLeavesBtn(false);
    }
  }, []);

  return (
    <Grid sx={{ mx: 3}}>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            <span
              style={{
                cursor: 'pointer',
                marginRight: '3px'
              }}
              onClick={() => {
                navigate('/leave-management')
              }}
            >
              Leave Management
            </span>
            <span
              style={{
                fontSize: '14px',
                fontWeight: '550',
                color: '#223354'
              }}
            >
             / PM/RM Pending Requests
            </span>
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
        <Grid item>
          <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-leave`);
              }}
            >
              Apply Leave
          </Button>
          {/* <Button
            sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/apply-wfh`);
            }}
          >
            Apply Work From Home
          </Button> */}
          {employeeType === 'Permanent' && (
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-lieu-leave`);
              }}
            >
              Lieu Leave Eligibility
            </Button>
          )}
          {isDisabledEmployeeLeavesBtn && (
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/employee-leaves`);
              }}
            >
              Employee Leaves
            </Button>
          )}
          <Button
            sx={{
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/my-leave-history/id`);
            }}
          >
            My Leave History
          </Button>
        </Grid>
    </Grid>
      <Card>
        <Grid sx={{ px: 2, py: 2 }} item xs={8}>
          <TextField
            sx={{ width: 400, mr: 2 }}
            size="small"
            id="pendingLeaveSearchField"
            placeholder="Search (Requestor Name / PM / RM / Leave Type)"
            InputProps={{
              style: { fontSize: '12px', height: '1.75rem' },
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{ color: '#d3d3d3' }}
                    style={{ fontSize: '15px' }}
                  />
                </InputAdornment>
              )
            }}
            value={searchString}
            onChange={e => setSearchString(e.target.value)}
          />
          <Button
            sx={{
              mt: { xs: 2, md: 0 },
              color: `${!toggleFilter && 'gray'}`
            }}
            variant="outlined"
            startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
            style={{ height: '1.75rem', fontSize: '12px' }}
            onClick={() => {
              setToggleFilter(!toggleFilter);
              setIsSelectToDate('');
              setIsSelectFromDate('');
              setToDate('');
              setFromDate('');
              setRequestorName(' ');
              setReportingManager(' ');
              setLeaveType(' ');
              setIsDisable(true);
              setIsDisabledClearBtn(true);
              setSelectFormDate('');
              setSelectToDate('');
            }}
          >
            Filters
          </Button>
        </Grid>
        {toggleFilter && (
          <form>
            <Grid
              container
              spacing={2}
              style={{
                padding: '1rem',
                paddingTop: 0,
                justifyContent: 'between'
              }}
            >
              <Grid item xs={4}>
                <InputLabel
                  style={{
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}
                >
                  Requestor Name
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    sx={{ mt: 1 }}
                    style={{
                      fontSize: '10px',
                      height: '2rem'
                    }}
                    fullWidth
                    size="small"
                    value={requestorName || ' '}
                    onChange={(e) => {
                      setRequestorName(e.target.value);
                      filterMandatoryFled(e.target.value);
                      setIsDisabledClearBtn(false);
                    }}
                  >
                    <ListSubheader>
                      <TextField
                        size="small"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key !== 'Escape') {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    <MenuItem
                      value={' '}
                      style={{ display: 'none' }}
                      disabled
                    >
                      Select Name
                    </MenuItem>
                    {requestorNames?.map((name) => (
                      <MenuItem value={name}>{name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <InputLabel
                  style={{
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}
                >
                  PM/RM
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    sx={{ mt: 1 }}
                    id="reportingManager"
                    style={{
                      fontSize: '10px',
                      height: '2rem'
                    }}
                    fullWidth
                    size="small"
                    value={reportingManager || ' '}
                    onChange={(e) => {
                      setReportingManager(e.target.value);
                      filterMandatoryFled(e.target.value);
                      setIsDisabledClearBtn(false);
                    }}
                  >
                    <ListSubheader>
                      <TextField
                        size="small"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key !== 'Escape') {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    <MenuItem
                      value={' '}
                      style={{ display: 'none' }}
                      disabled
                      hidden
                    >
                      Select Name
                    </MenuItem>
                    {reporterNames?.map((name) => (
                      <MenuItem value={name}>{name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <InputLabel
                  style={{
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}
                >
                  Leave Type
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    sx={{ mt: 1 }}
                    id="leaveType"
                    style={{
                      fontSize: '10px',
                      height: '2rem'
                    }}
                    fullWidth
                    size="small"
                    value={leaveType || ' '}
                    onChange={(e) => {
                      setLeaveType(e.target.value);
                      filterMandatoryFled(e.target.value);
                      setIsDisabledClearBtn(false);
                    }}
                  >
                    <ListSubheader>
                      <TextField
                        size="small"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key !== 'Escape') {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    <MenuItem
                      value={' '}
                      style={{ display: 'none' }}
                      disabled
                      hidden
                    >
                      Select Type
                    </MenuItem>
                    {leaveTypes?.map((name) => (
                      <MenuItem value={name}>{name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <InputLabel
                  style={{
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}
                >
                  From
                </InputLabel>
                <div style={{ marginTop: 7}}>
                  <FormControl fullWidth>
                    <DatePicker
                      InputProps={{
                        className: 'date-picker-leaveManagement'
                      }}
                      renderInput={(params) => (
                        <TextField {...params} id="fromDate" />
                      )}
                      value={selectFormDate ? selectFormDate : null}
                      onChange={(newValue) => {
                        if (newValue) {
                          setIsDisabledClearBtn(false);
                          setIsSelectFromDate('');
                          setFromDate(moment(newValue).format('DD/MM/YYYY'));
                          setSelectFormDate(moment(newValue).format('YYYY-MM-DD'));
                          setToDate('');
                          setSelectToDate('');
                          setIsDisable(true);
                          setIsSelectToDate("To date is mandatory field");
                        }
                      }}
                    />
                  </FormControl>
                  </div>
                {isSelectFromDate && (
                  <>
                    <Typography
                      style={{
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {isSelectFromDate}
                    </Typography>
                  </>
                )}
              </Grid>
              <Grid item xs={4}>
                <InputLabel
                  style={{
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}
                >
                  To
                </InputLabel>
                <div style={{ marginTop: 7}}>
                  <FormControl fullWidth>
                  <DatePicker
                      disabled={!fromDate}
                      InputProps={{
                        className: 'date-picker-leaveManagement'
                      }}
                      minDate={new Date(selectFormDate)}
                      renderInput={(params) => (
                        <TextField {...params} id="filterToDate" />
                      )}
                      value={selectToDate ? selectToDate : null}
                      onChange={(newValue) => {
                        if (newValue) {
                          setIsDisabledClearBtn(false);
                          setIsSelectToDate('')
                          setToDate(moment(newValue).format('DD/MM/YYYY'));
                          setSelectToDate(moment(newValue).format('YYYY-MM-DD'));
                          if (!fromDate) {
                            setIsDisable(true);
                            setIsSelectFromDate(
                              'Form date is mandatory field'
                            );
                          } else {
                            setIsDisable(false);
                          }
                        }
                      }}
                    />
                  </FormControl>
                  </div>
                {isSelectToDate && (
                  <>
                    <Typography
                      style={{
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {isSelectToDate}
                    </Typography>
                  </>
                )}
              </Grid>
              <Grid
                item
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: 16,
                  marginLeft: 'auto',
                  alignItems: 'flex-end'
                }}
                xs={4}
              >
                <Button
                  sx={{ mt: { xs: 2, md: 0 }, mr: 1 }}
                  variant="outlined"
                  style={{
                    height: '1.75rem',
                    fontSize: '12px'
                  }}
                  id="filterClear"
                  disabled={isDisabledClearBtn}
                  className={isDisabledClearBtn &&'clear-btn'}
                  onClick={() => {
                    setRequestorName(' ');
                    setReportingManager(' ');
                    setLeaveType(' ');
                    setFromDate('');
                    setToDate('');
                    setIsDisable(true);
                    setIsDisabledClearBtn(true);
                    getLeaveList(true);
                    setSearchString('');
                    setIsSelectToDate('');
                    setIsSelectFromDate('');
                    setSelectFormDate('');
                    setSelectToDate('');
                    if (inputRefFrom.current) {
                      inputRefFrom.current.value = ''
                    }
                    if (inputRefTo.current) {
                      inputRefTo.current.value = ''
                    }
                  }}
                >
                  Clear
                </Button>
                <Button
                  sx={{ mt: { xs: 2, md: 0 } }}
                  id="filterSubmit"
                  variant="outlined"
                  type="button"
                  style={{
                    height: '1.75rem',
                    fontSize: '12px'
                  }}
                  onClick={() => getLeaveList()}
                  disabled={isDisabled}
                  className={isDisabled &&'filter-btn'}
                >
                  Filter
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
        <Divider />
        <TableContainer className="tableContainer">
          <Table style={{ borderCollapse: 'separate' }} size="small">
            <TableHead>
              <CustomTableRow>
                {/* <TableCell>
                  <Checkbox
                    color="primary"
                    size="small"
                    onChange={(e) => checkAll(e.target.checked)}
                  />
                </TableCell> */}
                <TableHeaderCell
                  content="Requestor Name"
                  smallFont
                  sort
                  setSortType={setSortNameType}
                  sortType={sortNameType}
                />
                <TableHeaderCell 
                  content="Requested Date" 
                  smallFont 
                  sort
                  setSortType={setSortDate}
                  sortType={sortDate}/>
                <TableHeaderCell content="Leave Type" smallFont />
                <TableHeaderCell content="From" smallFont />
                <TableHeaderCell content="To" smallFont />
                <TableHeaderCell content="Day(s)" smallFont isNotCapitalize={true}/>
                <TableHeaderCell content="PM/RM" smallFont />
                <TableHeaderCell content="Status" smallFont />
              </CustomTableRow>
            </TableHead>

            <TableBody>
              {paginatedLeaveList &&
                paginatedLeaveList.map((item) => {
                  return (
                    <TableRow hover>
                      {/* <TableCell style={{ width: '10%' }}>
                        <Checkbox
                          color="primary"
                          size="small"
                          checked={item.isCheck}
                        />
                      </TableCell> */}
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {item.leaveRequester?.name}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {item.leaveRequestDate}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.leaveType}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.fromDate}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.toDate}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.numberOfDays}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.rm?.name}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.status}
                        </Typography>
                      </TableColumnCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {paginatedLeaveList?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )}
        <Box p={2}>
          <TablePagination
            sx={{
              fontSize: '12px',
              '.MuiTablePagination-displayedRows': {
                fontSize: '12px'
              },
              '.MuiTablePagination-selectLabel': {
                fontSize: '12px'
              }
            }}
            component="div"
            count={filteredLeaveList?.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </Box>
      </Card>
    </Grid>
  );
};

RmPendingRequest.propTypes = {};

RmPendingRequest.defaultProps = {};

export default RmPendingRequest;
